<template>
  <div class="bg-white md__card--holder">
   

    <UserPickerModal
      :visible="modals.assignedBy"
      title="Assigned By"
      role="CREATOR"
      :multi="false"
      v-model="task.assignedBy"
      @okClicked="_onAssignedByUsersChanged"
      @closeClicked="modals.assignedBy = false"
    />

    <UserPickerModal
      :visible="modals.assignedTo"
      title="Assigned To"
      role="ASSIGNEE"
      :multi="false"
      v-model="task.assignedTo"
      @okClicked="_onAssignedToUsersChanged"
      @closeClicked="modals.assignedTo = false"
    />

    <UserPickerModal
      :visible="modals.cc"
      title="CCed To"
      role="CC"
      :multi="true"
      v-model="task.cc"
      @okClicked="_onCCUsersChanged"
      @closeClicked="modals.cc = false"
    />

    <UserPickerModal
      :visible="modals.csu"
      title="CSU To Client"
      role="CLIENT"
      :multi="true"
      v-model="task.csu"
      @okClicked="_onCSUUsersChanged"
      @closeClicked="modals.csu = false"
    />

    <div class="card d-flex flex-column shadow-none">
      <!-- Card header -->
      <div
        class="chat-head card-header mb-auto d-flex flex-wrap align-items-center"
      >
        <!-- mobile close icon -->
        <!-- <a class="chat-close btn-close visible-xs"
          ><i class="fa fa-times"></i
        ></a> -->
        <!-- Title -->
        <div class="d-flex chat-header-container w-100 row mb-2 mx-md-12">
          <div
            :contenteditable="false"
            @keypress.enter.prevent="onTitleChanged($event)"
            @blur="onTitleChanged($event)"
            class="col-md-12 h3 mb-0  p-0 task-title"
            v-html="'Change Users for '+editTitle"
             @focus="_onTitleFocusClicked"
          ></div>

        </div>
      </div>

      <!-- Card Body -->


      <div class="chat-message bottom-bar">
        <div class="row mx-0">
          <div class="col-xl-12 comment-box chat-box">
           
            <div class="card-body chat-box__top bb-0">
              <div class="d-flex comment-header w-100 justify-content-between">
                <div class="comment-header__left d-flex align-self-center">
                  <!-- <div class="d-inline-flex mr-2 align-self-center"><i class="fas fa-arrow-right text-xs"></i></div> -->
                  <div class="chat-admin mr-4 d-flex">
                    <div
                      class="avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int"
                    >
                      <a
                        href="javascript:void(0)"
                        v-if="task.assignedBy"
                        @click="modals.assignedBy = canEdit"
                        class="to-2 avatar avatar--38 rounded-circle text-md"
                        :class="
                          userAvatar(task.assignedBy && task.assignedBy.user).bg
                        "
                      
                        data-placement="top"
                        v-tooltip.top-center="
                          task.assignedBy.user.first_name +
                            ' ' +
                            task.assignedBy.user.last_name
                        "
                        data-target="offcanvascced_int"
                        data-offcanvasfrom="offcanvas"
                      >
                        <span
                          v-if="
                            !userAvatar(task.assignedBy && task.assignedBy.user)
                              .hasImage
                          "
                          >{{
                            userAvatar(task.assignedBy && task.assignedBy.user)
                              .avatar
                          }}</span
                        >
                        <img
                          v-if="
                            userAvatar(task.assignedBy && task.assignedBy.user)
                              .hasImage
                          "
                          alt="Image placeholder"
                          :src="
                            userAvatar(task.assignedBy && task.assignedBy.user)
                              .avatar
                          "
                        />
                      </a>
                    </div>
                    <div
                      class="d-inline-flex pr add-icn align-self-center ml-2 mr-2"
                    >
                      <a><i class="fas fa-arrow-right text-xs"></i></a>
                    </div>
                    <div
                      class="avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int"
                    >
                      <a
                        v-if="task.assignedTo"
                        href="javascript:void(0)"
                        @click="modals.assignedTo = task && canEdit"
                        class="to-2 avatar avatar--38 rounded-circle text-md"
                        :class="
                          userAvatar(task.assignedTo && task.assignedTo.user).bg
                        "
                       
                        v-tooltip.top-center="
                          task.assignedTo.user.first_name +
                            ' ' +
                            task.assignedTo.user.last_name
                        "
                        data-target="offcanvascced_int"
                        data-offcanvasfrom="offcanvas"
                      >
                        <span
                          v-if="
                            !userAvatar(task.assignedTo && task.assignedTo.user)
                              .hasImage
                          "
                          >{{
                            userAvatar(task.assignedTo && task.assignedTo.user)
                              .avatar
                          }}</span
                        >
                        <img
                          v-if="
                            userAvatar(task.assignedTo && task.assignedTo.user)
                              .hasImage
                          "
                          alt="Image placeholder"
                          :src="
                            userAvatar(task.assignedTo && task.assignedTo.user)
                              .avatar
                          "
                        />
                      </a>

                      <a
                        v-if="!task.assignedTo"
                        @click="modals.assignedTo = canEdit"
                        href="javascript:void(0)"
                        class="to-3 avatar avatar--38 rounded-circle"
                        v-tooltip.top-center="`Add new user`"
                        data-target="offcanvascced_int"
                        data-offcanvasfrom="offcanvas"
                      >
                        <i class="fas fa-plus text-xs"></i>
                      </a>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mr-4 mb-sm-0">
                    <div class="comment-header__cc">
                      <div
                        class="avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int"
                      >
                      
                        <a
                          v-for="(u, i) in task.cc"
                          @click="modals.cc = task && canEdit"
                          :key="i"
                          href="javascript:void(0)"
                          class="to-2 avatar avatar--38 rounded-circle text-md"
                          :class="userAvatar(u && u.user).bg"
                          v-tooltip.top-center="u.user.first_name + ' ' + u.user.last_name"
                        >
                          <span v-if="!userAvatar(u && u.user).hasImage">{{
                            userAvatar(u && u.user).avatar
                          }}</span>
                          <img
                            v-if="userAvatar(u && u.user).hasImage"
                            alt="Image placeholder"
                            :src="userAvatar(u && u.user).avatar"
                          />
                        </a>

                        <a
                          @click="modals.cc = task && canEdit"
                          href="javascript:void(0)"
                          class="to-3 avatar avatar--38 rounded-circle"
                          v-tooltip.top-center="`Add user`"
                          data-target="offcanvascced_int"
                          data-offcanvasfrom="offcanvas"
                        >
                          <i class="fas fa-plus text-xs"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label class="comment-header__switch custom-toggle">
                      <input
                        type="checkbox"
                        id="grayscale"
                        value="grayscale"
                        v-model="hasCsu"
                        v-if="canEdit"
                        name="grayscale_switch"
                        class="custom-control-input switch-btn"
                      />
                      <!-- <input type="checkbox"> -->
                      <span
                        class="custom-toggle-slider rounded-circle"
                        id="showRadio"
                        data-label-off="OFF"
                        data-label-on="ON"
                      ></span>
                    </label>
                    <div
                      v-if="hasCsu"
                      class="comment-header__cc__ext pl-2 ml-1"
                    >
                      <div
                        class="avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-ext"
                      >
                        <a
                          v-for="(u, i) in task.csu"
                          :key="i"
                          @click="modals.csu = task && canEdit"
                          href="javascript:void(0)"
                          class="to-2 avatar avatar--38 rounded-circle text-md"
                          :class="userAvatar(u && u.user).bg"
                          data-toggle="tooltip"
                          :title="u.user.first_name + ' ' + u.user.last_name"
                          data-target="offcanvascced_int"
                          data-offcanvasfrom="offcanvas"
                        >
                          <span v-if="!userAvatar(u && u.user).hasImage">{{
                            userAvatar(u && u.user).avatar
                          }}</span>
                          <img
                            v-if="userAvatar(u && u.user).hasImage"
                            alt="Image placeholder"
                            :src="userAvatar(u && u.user).avatar"
                          />
                        </a>

                        <a
                          @click="modals.csu = task && canEdit"
                          href="javascript:void(0)"
                          class="to-3 avatar avatar--38 rounded-circle"
                          data-toggle="tooltip"
                          title="Add User"
                          data-target="offcanvascced_int"
                          data-offcanvasfrom="offcanvas"
                        >
                          <i class="fas fa-plus text-xs"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="comment-header__right align-self-center pr-2">
                  <img
                    src="../../assets/img/brand/down-arrow 1.png"
                    alt="arrow down"
                    class="arw-dwn"
                  />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import UserPickerModal from "@/app/components/UserPickerModal.vue";
import UserPicker from "@/app/components/UserPicker.vue";
import LightBox from "@/libs/lightbox/LightBox.vue";
import moment from "moment";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { isMobile } from "mobile-device-detect";

//import LightBox from 'vue-image-lightbox'

export default {
  name: "ChangeTaskOwner",
  props: ["editId", "data", "quoteView"],
  data() {
    return {
      isMobile: isMobile,
      resource: {},
      quoteExpanded: this.quoteView || false,
      resourceAddVisible: false,
      hasCsu: false,
      selectedResource: {},
      lightbox: {
        images: [],
        startIndex: 0
      },
      modals: {
        assignedBy: false,
        assignedTo: false,
        cc: false,
        csu: false
      },
      project_id: null,
      uploading: false,
      attachments: [],
      comment: null,
      deadline: moment().format("YYYY-M-D"),
      task: {
        asset_users: [],
        title: "Unnamed Task"
      },
      message: null,
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL + "/v2/attachments",
        thumbnailWidth: 150,
        maxFilesize: 2,
        thumbnailWidth: 200,
        paramName: "attachment",
        headers: { Authorization: "Bearer " + this.$auth.getToken() }
      },

      editTitle: "Unnamed Task"
    };
  },
  components: {
    HtmlEditor,
    flatPicker,
    UserPickerModal,
    UserPicker,
    LightBox
  },
  validations: {
    projectTitle: {
      required,
      minLength: minLength(4)
    },
    projectType: {
      required
    },
    client: {
      required
    }
  },

  watch: {
    editId(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");

      if (newVal != oldVal) {
        if (newVal) {
          this.fetchTask(newVal);
        } else {
          this.initForm();
        }
      } else {
        this.initForm();
      }
    }
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("common", ["roles", "resources", "currencies"]),
    numLines() {
      return (this.comment && this.comment.split(/\r\n|\r|\n/).length) || 1;
    },
    canEdit() {
      if (this.task.id)
        return (
          this.task && this.task.permission && this.task.permission.edit == 1
        );
      else return true;
    },
    canComment() {
      if (this.task.id)
        return (
          this.task && this.task.permission && this.task.permission.comment == 1
        );
      else return true;
    },

    taskBudget() {
      let totalHours = 0;
      let totalCost = 0;
      let t = this.task || {};

      totalCost = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
      totalHours = parseInt(t.quoted_hours || 0);
      const dp = isNaN(parseInt(t.discount_percentage))
        ? 0
        : parseInt(t.discount_percentage);
      const numOfDays = parseInt(t.no_of_days || 1);
      totalCost = (totalCost - (totalCost * dp) / 100) * numOfDays;
      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(1) + "k";
      }

      return (
        (this.profile && this.profile.currency.symbol) +
        totalCost +
        " | " +
        totalHours +
        " Hours"
      );
    }
  },

  created() {
    //hide sidebar and modals on esc key
    document.addEventListener("keyup", evt => {
      if (evt.keyCode === 27) {
        let canHideSideBar = true;
        Object.keys(this.modals).map(key => {
          if (this.modals[key]) {
            this.modals[key] = false;
            canHideSideBar = false;
          }
          return key;
        });

        //console.log("esc", canHideSideBar)
        if (canHideSideBar) {
          this.$emit("closeClick");
        }
      }
    });
  },

  async mounted() {
    console.log("mounted+++++++", this.$route);
    // console.log(this.$router, this.$route, "ddddd")

    this.project_id = this.$route.params["id"];
    this.setLoading(true);
    await this.fetchRoles();
    await this.fetchResources();
    if (!this.editId) {
      this.initForm();
    } else {
      //this.editTitle = "Edit Task";
      await this.fetchTask(this.editId);
      //this.deadline = moment(this.task.deadline).format("DD-MM-YYYY")
    }

    this.setLoading(false);

    this.$nextTick(() => {
      // $('[data-toggle="tooltip"]').tooltipster({
      //   theme: "tooltipster-borderless"
      // });
    }, 400);
  },

  methods: {
    ...mapActions("user", ["fetchAllUsers"]),
    ...mapActions("task", [
      "fetchSingleTask",
      "createTask",
      "updateTask",
      "createAssetThread"
    ]),
    ...mapActions("common", [
      "fetchRoles",
      "fetchResources",
      "deteteAttachment",
      "fetchCurrencies"
    ]),
    ...mapMutations(["setGanttRender", "setLoading"]),

    initForm() {
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let assigner = { ...this.profile };

      this.editTitle = "Unnamed Task";
      this.task = {
        id: null,
        assignedBy: { user: assigner, asset_role: role },
        assignedTo: { user: assigner, asset_role: role },
        name: this.editTitle,
        comments: [],
        csu: [],
        cc: []
      };
      this.deadline = moment().format("YYYY-M-D");
    },
   _onTitleFocusClicked() {
      if(this.editTitle == "Unnamed Task") {
        this.editTitle = ""
      }   
    },
    

    _onCancelQuoteClicked() {
      this.quoteExpanded = false;
    },

    _onHoursClicked() {
      this.quoteExpanded = true;
    },

    async _onAddRateClicked() {
      await this.fetchCurrencies();
      this.resourceAddVisible = true;
    },

    _onFileAdded() {
      this.uploading = true;
    },
    _onFileRemoved(file) {},

    _onComplete(file, status, xhr) {
      this.uploading = false;

      if (file.errorMessage) {
        this.$snack.success(file.errorMessage);
      } else {
        let body = JSON.parse(xhr.response);
        this.attachments = [...this.attachments, body.data];
        console.log(xhr.response, "came after upload");
      }
    },

    onSaveResourceClicked() {},

    async _onSaveQuoteClicked() {
      if (this.task.id) {
        try {
          const r = await this.saveTask(false);
          this.quoteExpanded = false;
          if (r) {
            this.$snack.success("Quote updated Successfully");
          }
        } catch (e) {}
      } else {
        try {
          const r = await this.saveTask(false);
          this.quoteExpanded = false;
          if (r) {
            this.$snack.success("Quote Created Successfully");
          }
        } catch (e) {}
      }
    },

    async _onCompleteClicked() {
      if (this.task.id) {
        try {
          this.task.status = this.task.status == "CLOSED" ? "OPEN" : "CLOSED";
          await this.saveTask(false);
        } catch (e) {}
      }
    },

    onDeadlineChanged(deadline) {
      console.log("hahahah", deadline, moment(deadline[0]).format("YYYY-M-D"));

      if (this.task.id) {
        this.task.deadline = moment(deadline[0]).format("YYYY-M-D");
        this.task.end_date = moment(deadline[0]).format("YYYY-M-D");
        this.saveTask(false);
      }
    },

    _onUploadClicked() {
      if (
        this.task &&
        this.task.permission &&
        this.task.permission.comment == 1
      ) {
        document.getElementsByClassName("dz-clickable")[0].click();
      } else {
        this.$snack.success("You dont have permission to comment");
      }
    },

    async _onDeleteAttachment(attachment) {
      try {
        await this.deteteAttachment(attachment);
        this.attachments = this.attachments.filter(r => r.id != attachment.id);
      } catch (e) {
        console.log(e);
      }
    },

    async onTitleChanged(event) {
      this.editTitle = event.target.innerHTML;
      let existingTitle = this.task.name;
      if (this.task && this.task.permission && this.task.permission.edit == 0)
        return false;
      if (event.target.innerHTML.length < 5) {
        swal({
          title:
            "Are you sure you want to change the name of this ticket from " +
            existingTitle +
            " to " +
            event.target.innerHTML +
            "?",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, change it!",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.task.name = this.editTitle;
            if (existingTitle != this.task.name && this.task.id)
              this.saveTask(false);
            return false;
          } else {
            this.editTitle = existingTitle;
            return false;
          }
        });
        return false;
      } else if (event.target.innerHTML.length > 50) {
        swal({
          title: "Task title is too long",
          type: "warning",
          // showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "OK",
          buttonsStyling: false
        }).then(result => {});
        return false;
      } else {
        this.task.name = this.editTitle;
        //alert(this.task.id)
        if (existingTitle != this.task.name && this.task.id != null)
          this.saveTask(false);
        return false;
      }
    },

    async saveTask(refresh = true) {
      this.task.parent_id = this.project_id;
      let body = { ...this.task };
      if (body.discount_percentage == "None") {
        body.discount_percentage = 0;
      }

      if (body.id) {
        try {
          let res = await this.updateTask(body);
          //await this.fetchTask(this.task.id)
          await this.fetchTask(body.id, refresh);
          this.setGanttRender();
          this.$emit("taskCreated", refresh);
        } catch (e) {
          console.log("Error in saving task ", e);
          this.$snack.success("Error occured while saving task");
        }
      } else {
        if (body.name == null || body.name == "") {
          this.$snack.success("Task title is required");
          return Promise.reject(false);
        }

        if (!body.assignedBy) {
          this.$snack.success("Task From is required");
          return Promise.reject(false);
        }

        if (!body.assignedTo) {
          this.$snack.success("Task To is required");
          return Promise.reject(false);
        }

        let res = await this.createTask(body);
        //await this.fetchTask(this.task.id)
        await this.fetchTask(res.data.id, refresh);
        this.setGanttRender();
        this.$emit("taskCreated", refresh);
        return Promise.resolve(true);
      }
    },

    onResourceChanged() {
      this.task.hourly_cost = this.task.resource.hourly_cost;
    },

    async fetchTask(val, refresh) {
      try {
        const res = await this.fetchSingleTask({ val, refresh });
        this.task = res.data || {};
        if (
          this.task.discount_percentage == 0 ||
          this.task.discount_percentage
        ) {
          this.task.discount_percentage = "None";
        }

        this.deadline = moment(this.task.end_date).format("YYYY-M-D");
        console.log(
          "daidai",
          moment(this.task.end_date),
          moment(this.task.end_date).format("YYYY-M-D")
        );

        this.editTitle = this.task.name;

        this.task.comments.map(comment => {
          this.lightbox.images = [
            ...this.lightbox.images,
            ...comment.attachments.map(att => {
              att.thumb = att.src = att.file_url;
              att.type = att.type;
              return att;
            })
          ];
        });
      } catch (e) {
        this.task = {};
        this.$snack.success("Could not fetch task");
      }
    },

    userAvatar(user) {
      let avatar = "";
      let bg_colors = [
        "bg-success",
        "bg-info",
        "bg-default",
        "bg-darker",
        "bg-danger"
      ];
      let bg = "bg-success";
      let hasImage = false;
      if (user) {
        if (user.profile_pic != null) {
          avatar = user.profile_pic.file_url;
          hasImage = true;
        } else {
          hasImage = false;
          let ch =
            user.first_name && user.first_name.substring(0, 1).toUpperCase();
          bg = bg_colors[(ch.charCodeAt(0) + user.first_name.length) % 5];
          avatar =
            user.first_name &&
            user.first_name.substring(0, 1).toUpperCase() +
              (
                (user.last_name && user.last_name.substring(0, 1)) ||
                ""
              ).toUpperCase();
        }
      } else {
        avatar = "NU";
        //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
      }

      // <span data-toggle="tooltip" data-trigger="hover" title="No User" class="d-flex mr-1"><a href="#" class="avatar avatar-name avatar-sm  '+bg+' text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas">NU</a></span>

      return {
        hasImage: hasImage,
        avatar: avatar,
        bg: bg
      };
    },

    _onAssignedByUsersChanged(data) {
      this.task.assignedBy = data;
      this.modals.assignedBy = false;
      if (this.task.id) this.saveTask(false);
    },

    _onAssignedToUsersChanged(data) {
      console.log(data);
      this.task.assignedTo = data;
      this.modals.assignedTo = false;
      if (this.task.id) this.saveTask(false);
    },

    _onCCUsersChanged(data) {
      this.task.cc = data;
      this.modals.cc = false;
      if (this.task.id) this.saveTask(false);
    },

    _onCSUUsersChanged(data) {
      this.task.csu = data;
      this.modals.csu = false;
      if (this.task.id) this.saveTask(false);
    },

    async handleSubmit() {
      
      if (this.comment == null || this.comment == "") {
        return;
      }

      if (this.task.name == null || this.task.name == "") {
        this.$snack.success("Task title is required");
        return;
      }

      if (!this.task.assignedBy) {
        this.$snack.success("Task From is required");
        return;
      }

      if (!this.task.assignedTo) {
        this.$snack.success("Task To is required");
        return;
      }

      // add task by and task to validations

      // if (this.task.months == null || this.task.months == "") {
      //   this.$snack.success("Months is required");
      //   return;
      // }

      // if (this.task.deadline == null || this.task.deadline == "") {
      //   this.$snack.success("Deadline is required");
      //   return;
      // }

      // if (this.task.resource) {
      //   if (this.task.hourly_cost == null || this.task.hourly_cost == "") {
      //     this.$snack.success("Please enter total rate");
      //     return;
      //   }

      //   if (this.task.quoted_hours == null || this.task.quoted_hours == "") {
      //     this.$snack.success("Please enter total hours");
      //     return;
      //   }
      // } else {
      //   this.$snack.success("Select price resource");
      // }

      let asset = {
        ...this.task,
        parent_id: this.project_id
      };

      if (asset.discount_percentage == "None") {
        asset.discount_percentage = 0;
      }

      if (this.editId) {
        asset.id = this.editId;
      }

      let body = {
        asset: asset,
        from_user: {
          user: this.profile
        },
        attachments: this.attachments,
        description: this.comment
      };

      try {
        let res = await this.createAssetThread(body);
        
        await this.fetchTask(res.data.asset.id);
        this.setGanttRender();
        this.$emit("taskCreated");
        this.comment = null;
        this.attachments = [];
      } catch (e) {
        console.log(e);
        this.$snack.success("Could not create thread");
      }
    },

    _onAttachmentClicked(attachment) {
      this.lightbox.startIndex = this.lightbox.images.findIndex(
        a => attachment.file_url == a.file_url
      );
      this.$refs["lb"].showImage(this.lightbox.startIndex);
    }
  } //end methods
};
</script>

<style scoped>
textarea.form-control {
  /* height: calc(1.5em + 1.25rem + 5px); */
  padding-right: 40px;
  padding-left: 20px;
}
.chat-head {
  position: relative;
}
.chat-head .chat-close {
  position: absolute;
  right: 10px;
  top: 5px;
  left: auto;
}
.chat-head .chat-close:hover {
  color: #11cdef !important;
}
.cancel-btn,
.success-btn {
  padding: 10px;
}
.btn-row .btn-col-left {
  padding-right: 5px;
}
.btn-row .btn-col-right {
  padding-left: 5px;
}
.form-control-chatbox {
  height: calc(1.5em + 1.25rem + 2px);
}
.title-btn .title-btn-child {
  padding: 11px 10px;
  box-shadow: none;
}

.title-btn .title-btn-child:hover {
  webkit-box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

@media only screen and (max-width: 991px) {
  .chat-header-container {
    flex-direction: column;
  }
  .title-btn {
    padding-top: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .title-btn {
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }
  .title-btn-child {
    margin-left: 0 !important;
  }
}
</style>
